import React from 'react';

const preventDefault = e => {
  e.preventDefault();
};

export default class extends React.PureComponent {
  render() {
    const { position = 'bottom', text, ...restProps } = this.props;
    return (
      <div data-rh={text} data-rh-at={position} {...restProps} onClick={preventDefault} />
    );
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/components/Tooltip.js